import {request} from '@/helpers/apiClient'
import {WAREHOUSE_CONFIG} from '@/utils/constants/apiConfig/Products/Fullfillment/warehouseConfig'

export const getWarehouseList = () => request(WAREHOUSE_CONFIG.WAREHOUSE_TARGETS)

export const getWarehouseUploadHistory = () => request(WAREHOUSE_CONFIG.WAREHOUSE_UPLOAD_HISTORY)